import { BusinessPurpose, EntityType, TransactionType } from "./Enums"
import { Franchise, Naics } from "./index";

export class Company {
  ID: string;
  NAICS: Naics;
  NAME: string;
  DBA: string;
  ENTITY_TYPE: EntityType;
  ENTITY_NAME: string;
  IS_FRANCHISE: boolean;
  FRANCHISE: Franchise;
  BUSINESS_PURPOSE: BusinessPurpose;
  TRANSACTION_TYPE: TransactionType;
  OTHER_BUSINESS_PURPOSE: string;

  // helper
  NAICS_NAME: string;
  FRANCHISE_NAME: string;

  static parse(json: any): Company {
    if (json) {
      const cmpny = new Company();
      cmpny.ID = json.ID;
      if (json.NAICS)
        cmpny.NAICS = Naics.parse(json.NAICS);
      cmpny.NAME = json.NAME;
      cmpny.DBA = json.DBA;
      cmpny.ENTITY_TYPE = EntityType[<string>json.ENTITY_TYPE];
      cmpny.ENTITY_NAME = json.ENTITY_NAME;
      cmpny.IS_FRANCHISE = json.IS_FRANCHISE;
      if (json.FRANCHISE)
        cmpny.FRANCHISE = Franchise.parse(json.FRANCHISE);

      cmpny.BUSINESS_PURPOSE = BusinessPurpose[<string>json.BUSINESS_PURPOSE];
      cmpny.TRANSACTION_TYPE = TransactionType[<string>json.TRANSACTION_TYPE];
      
      cmpny.OTHER_BUSINESS_PURPOSE = json.OTHER_BUSINESS_PURPOSE;

      if (json.NAICS_NAME)
        cmpny.NAICS_NAME = json.NAICS_NAME;
      if (json.FRANCHISE_NAME)
        cmpny.FRANCHISE_NAME = json.FRANCHISE_NAME;

      return cmpny;
    } else { return null; }
  }

  static parseArray(json: Array<any>): Array<Company> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Company.parse(j));

    return arr;
  }

}

